import { AnyAction, AsyncThunkAction, createListenerMiddleware, isRejected } from '@reduxjs/toolkit';

import { globalConfig } from '../config';
import { QueryErrorPayload } from '../types';
import { BaseQueryFn, BaseQueryMeta } from '@reduxjs/toolkit/query';

export const QUERY_ERROR = 'QUERY_ERROR';

export type QueryAction = AsyncThunkAction<any, any, never> & {
  payload: QueryErrorPayload;
  meta: BaseQueryMeta<BaseQueryFn>;
};
export type RejectedQueryAction = ReturnType<QueryAction>;

export const isRejectedQuery = (action: AnyAction): action is RejectedQueryAction => {
  if (isRejected(action) && action.payload) {
    const payload = action.payload as Partial<QueryErrorPayload>;
    return payload.status === 'FETCH_ERROR' || (payload.status || 0) >= 400;
  }
  return false;
};

export const queryErrorMiddleware = createListenerMiddleware();
queryErrorMiddleware.startListening({
  matcher: isRejectedQuery,
  effect: (action: QueryAction, api) => {
    if (globalConfig?.errorHandler) {
      globalConfig.errorHandler(action, api.dispatch);
    }
  },
});
